import Vue from 'vue';

import Frame from '@/presentation/slides/Frame.vue';
Vue.component('Frame', Frame);

import { Drag, Drop } from 'vue-drag-drop';
Vue.component('drag', Drag);
Vue.component('drop', Drop);

import I from '@/components/I.vue';
Vue.component('I', I);

import Loaded from '@/components/Loaded.vue';
Vue.component('Loaded', Loaded);

import PGroup from '@/components/PGroup.vue';
Vue.component('PGroup', PGroup);

import PLabel from '@/components/PLabel.vue';
Vue.component('PLabel', PLabel);

import PValue from '@/components/PValue.vue';
Vue.component('PValue', PValue);

import Compass from '@/components/Compass.vue';
Vue.component('Compass', Compass);

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);

import Instructions from '@/presentations/Instructions.vue';
Vue.component('Instructions', Instructions);

import BalanceBK from '@/charts/Balance.vue';
import D009BK from '@/presentations/company_slides/D009.vue';
import Liability from '@/presentation/slides/Liability.vue';
if (process.env.VUE_APP_BRAND === 'BK') {
  Vue.component('Balance', BalanceBK);
  Vue.component('D009', D009BK);
  Vue.component('Liability', Liability);
}

import BalanceGT from '@/charts/BalanceGT.vue';
import D009GT from '@/presentations/company_slides/D009GT.vue';
import LiabilityGT from '@/presentation/slides/LiabilityGT.vue';
if (process.env.VUE_APP_BRAND === 'GT') {
  Vue.component('Balance', BalanceGT);
  Vue.component('D009', D009GT);
  Vue.component('Liability', LiabilityGT);
}
